<header class="p-3 mb-3 border-bottom bg-light">
	<div class="container">
		<div class="row align-items-center">
			<div class="col-auto">
				<a href="/" class="d-flex align-items-center text-decoration-none">
					<img src="https://test.kula.pandadigital.co.za/assets/images/Panda%20-%20Icon%20(Dark%20Background).png"
						style="height: 3em;" />
				</a>
			</div>
			<div class="col text-center">
				<h3 class="mb-0">Secure File Download</h3>
			</div>
			<div class="col-auto ms-auto">
				<button type="button" class="btn btn-sm btn-outline-secondary align-items-center" (click)="logout()">
					<i class="bi bi-box-arrow-right me-2"></i> Logout
				</button>
			</div>
		</div>
	</div>
</header>

<div class="container mt-5">
	<div class="row mb-2">
		<div class="col text-end">
			<button type="button" class="btn btn-sm btn-outline-secondary align-items-center" (click)="downloadAll()">
				<i class="bi bi-box-arrow-down me-2"></i> Download all
			</button>
		</div>
	</div>
	<div class="row justify-content-center">

		<div class="col table-responsive">
			<table class="table table-striped table-hover align-middle table-bordered rounded">
				<thead class="table-light">
					<tr>
						<th>File Name</th>
						<th>Download</th>
					</tr>
				</thead>
				<tbody>
					@for (file of secureFiles; track $index) {
					<tr>
						<td>{{file.fileName}}</td>
						<td class="download">
							<div (click)="download(file)"><i class="bi bi-box-arrow-down me-2"></i></div>
						</td>
					</tr>
					}
				</tbody>
			</table>
		</div>
	</div>
</div>